import { styled } from "@mui/system";
import ModalUnstyled from "@mui/base/ModalUnstyled";

export const paperStyle = {
  // padding: 20,
  padding: "20px",
  // height: "169px",
  // width: "355px",
  // margin: "200px auto",
  // left: "477px",
  // top: "290px",
  borderRadius: "10px",
  border: "1px solid #F0F0F0",
};

export const btnStyle = {
  margin: "0px 0",
  backgroundColor: "#4483C7",
  height: "39px",
  // width: "355px",
  left: "0px",
  top: "25px",
  borderRadius: "10px",
  padding: "10px",
  background: "linear-gradient(87.29deg, #7068AF -42.06%, #EB2A33 120.03%)",
};

export const standartBtnStyle = {
  backgroundColor: "#4483C7",
  borderRadius: 10,
  padding: 10,
  background: "linear-gradient(87.29deg, #7068AF -42.06%, #EB2A33 120.03%)",
  fontWeight: '400',
  fontSize: 18,
};

export const TypographyStyle = {
  width: "355px",
  marginTop: "35px",
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
};
export const inputStyle = {
  marginTop: "12px",
  height: "44px",
  borderRadius: "10px",
  padding: "7px 14px 10px 0px",
  background: "#F0F0F0",
};
export const tagStyle = {
  backgroundColor:"#161728",
  borderRadius:10,
  margin: 3,
  color:'#FFFFFF'
};
export const tagIconstyle = {
  color: "white",
  fontSize:'1.2em',
  stroke: "white",
  strokeWidth: 2,
}
export const tagLabelStyle = {
  color:'#FFFFFF'
};
export const forgotPasswordStyle = {
  color: "#5C5D68",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "19.06px",
  marginLeft: "5px",
};
export const labelStyle = {
  display: "flex",
  marginTop: "5px",
  width: "315px",
  justifyContent: "space-between",
  textDecorationLine: "underline",
};

export const pStyle = {
  width: "315px",
  fontFamily: "SofiaPro",
  fontSize: "16px",
  fontWeight: "400",
  color: "#5C5D68",
  marginBottom: "11px",
};

export const h2Style = {
  fontFamily: "SofiaPro",
  fontWeight: "400",
  fontSize: "22px",
  color: "#161728",
  LineHeight:"16px"
};

export const h3Style = {
  fontFamily: "SofiaPro",
  fontWeight: "700",
  fontSize: "24px",
  color: "#161728",
  marginBottom: "6px",
};

export const h3StyleLight = {
  fontFamily: "SofiaPro",
  fontWeight: "700",
  fontSize: "20px",
  color: "#161728",
  marginBottom: "6px",
};

export const logoStyle = { marginTop: "0px" };

export const backgroundStyle = {
  // background: "#E5E5E5",
  // backgroundImage: `url(${logo})`,
  height: "92vh",
  alignItems: "center",
  display: "flex",
  margin: "0",
  justifyContent: "center",
};

export const checkListStyle = {
  marginTop: "20px",
  marginBottom: "20px",
};

export const alertStyle = {
  border: "aliceblue",
  color: "red",
  fontSize: "small",
  padding: 0,
  margin: "0px auto",
  // width: "315px",
};

export const avatarNameStyle = {
  color: "#FFFFFF",
  fontWeight: "400",
  fontSize: "14px",
  fontFamily: "SofiaPro",
};

export const singOutStyle = {
  textDecoration: "underline",
  color: "#9092B0",
  fontWeight: "400",
  fontSize: "14px",
  fontFamily: "SofiaPro",
};

export const settingStyle = {
  color: "white",
  display: "flex",
  alignItems: "center",
  marginLeft: "23px",
};

export const userMenuStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
};

export const headerStyle = { display: "flex", justifyContent: "space-between" };

export const avatarStyle = { marginLeft: "15px" };


export const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Backdrop = styled("div")`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`;

export const style = {
  bgcolor: "background.paper",
  p: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "white",
  borderRadius: "20px",
  width: "193px",
  height: "212px",
};

export const styleWidthL = {
  bgcolor: "background.paper",
  p: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "white",
  borderRadius: "20px",
  width: "460px",
  height: "212px",
};
